const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    INTERNAL_API_URL: 'https://ecljg3f0x6.execute-api.ap-southeast-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://iewrpzb7v7.execute-api.ap-southeast-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.au.forwood.one'
  },
  configurationService: {
    URL: 'https://config.au.forwood.one',
    WEBSOCKET: 'wss://l2a5ttj1n4.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;
